import { SHOULD_AUTOBATCH } from "@reduxjs/toolkit"
import { Middleware } from "redux"

const Batcher = (defaultResult: boolean, excludeActions: string[] = []) => {
  const middleware: Middleware = (store) => (next) => (action) => {
    // Skip batching for actions in the exclusion list
    // @ts-ignore
    if (!excludeActions.includes(action.type)) {
      // @ts-ignore
      action.meta ||= {}
      // @ts-ignore
      action.meta[SHOULD_AUTOBATCH] = defaultResult
    }
    return next(action)
  }
  return middleware
}

export default Batcher
